<script setup>
import { watch, ref, onMounted } from 'vue';
import { storeToRefs } from "pinia";
import { useFVStore } from "@/stores/formvibes";
import { CircleCloseFilled, Refresh, CloseBold } from '@element-plus/icons-vue';
import { Edit, DocumentAdd } from "@element-plus/icons-vue"

const props = defineProps(['row','closeDialog', 'selectedRow']);

const showDialog = ref(false)
const noteText = ref('')
const store = useFVStore();

const {notes,isSaving} = storeToRefs(store);
const noteLength = notes.value[props.row.id] || [];

const noteCount = ref(noteLength.length);

const plugin_url = window.fvGlobalVar.plugin_url;
const closeDialog = (e) => {
    // props.closeDialog();
    showDialog.value = false;
}


watch([notes],()=> {
    const count = notes.value[props.row.id] || [];
    noteCount.value = count.length;
},{ immediate: true, deep: true })

const addNote = async (e) => {
    e.stopPropagation();
    if(!noteText.value){
        return;
    }
    await store.addNote(props.row.id, noteText.value);
    showDialog.value = false;
    noteText.value = '';   
}
const addNoteClick = (e) => {
    e.stopPropagation();
    showDialog.value = true;
}
</script>
<template>
<div>
    <!-- add class condtionally if noteCount is greater than -->
    <div @click="addNoteClick" :class="['fv-add-note-wrapper', {'has-zero' : noteCount == 0}]">
        <!-- Add Notesss -->
        <!-- <img :src="`${plugin_url}assets/images/add_notes.svg`"/> -->
        <el-tooltip class="box-item" effect="light" content="Add Note" placement="top">
            <el-badge :value="noteCount" is-dot class="fv-note-count" color="green" show-zero="false" :offset=[-4,6]>
                <el-icon><DocumentAdd /></el-icon>
            </el-badge> 
        </el-tooltip>
        <!-- <el-badge :value="noteCount" class="fv-note-count" color="green" show-zero="false" :offset=[1,9]>
            <el-icon><Edit /></el-icon>
        </el-badge> -->
        
        <!-- <div style="top: -0.2rem" v-if="noteCount">
            <span style="min-width:1rem; min-height:1rem;">
                <span>
                    {{ noteCount }}
                </span>
            </span>
        </div> -->
        
    </div>
    <Teleport to="body" >
        <el-dialog 
            v-model="showDialog" 
            align-center
            :show-close="true"
            title="Add Note"
            class="fv-add-note-dialog"
            >
            <!-- <template #header="{ close, titleId, titleClass }">
                <div class="fv-header-title">
                    Add Note
                </div>
                <el-icon @click="close"><CloseBold /></el-icon>                
            </template> -->
            <el-input
                v-model="noteText"
                rows="3"
                type="textarea"
                placeholder="Write your note here..."
                v-if="!isSaving"
            />
            <div v-else class="fv-add-note-loading">
                <el-icon size="50" ><Refresh /></el-icon>
            </div>
            <template #footer="{}">
                <el-button @click="closeDialog">Cancel</el-button>
                <el-button @click="addNote" type="primary">Save</el-button>
            </template>
        </el-dialog>
    </Teleport>
</div>    
</template>